import {useAuth, useAuthSet, useAuthToken} from 'components/organisms/Providers/AuthProvider/AuthProvider';
import React, {useEffect, useRef, useState} from 'react';
import StyledLogoutPage from 'components/pages/Auth/LogoutPage/LogoutPage.styles';
import PropTypes from 'prop-types';
import {useAuthLogout} from 'services/auth/auth.hooks';
import {useComponentProps} from 'helpers/hooks/utils';
import {H6} from 'components/atoms/Text/Typography/Typography';
import constants from 'helpers/constants';
import {useLinkNavigate} from 'helpers/hooks/links';
import Box from 'components/atoms/Layout/Box/Box';
import CircularProgress from 'components/atoms/Progress/CircularProgress/CircularProgress';
import utils from 'helpers/utils';
import Navigate from 'components/organisms/Utils/Navigate/Navigate';
import {useLocation} from 'react-router-dom';

const LogoutPage = (props) => {
  const innerProps = useComponentProps(props, 'LogoutPage');

  const auth = useAuth();
  const setAuthLocal = useAuthSet(constants.appState.type.local);
  const setAuthSession = useAuthSet(constants.appState.type.session);

  const loggingOut = useRef(false);
  const token = useAuthToken();

  const location = useLocation();

  const [internalState, setInternalState] = useState({});

  const logout = Boolean(auth?.loggedIn || token);
  const reset = utils.location2URL(location)?.searchParams?.get('reset');

  const doLogout = useAuthLogout();
  const navigate = useLinkNavigate();

  useEffect(() => {
    const clearAuthStorage = (reset) => {
      setAuthLocal(reset ? null : (current) => {
        return current?.whiteLabel ? {
          whiteLabel: current?.whiteLabel
        } : null;
      });
      setAuthSession(reset ? null : (current) => {
        return current?.whiteLabel ? {
          whiteLabel: current?.whiteLabel
        } : null;
      });
    }

    if (logout) {
      if (!loggingOut.current) {
        loggingOut.current = true;
        if (auth?.authId) {
          doLogout.mutation.mutateAsync({authId: auth?.authId, $httpParams: { intercept: false }})
            .then(() => {
              setInternalState(utils.updater({loggedOut: true}, true));

              if (reset) {
                clearAuthStorage(true);
              }
            })
            .catch(() => {
              clearAuthStorage(reset);
              setInternalState(utils.updater({loggedOut: true}, true));
            });
        } else {
          clearAuthStorage(reset);
          setInternalState(utils.updater({loggedOut: true}, true));
        }
      }
    } else {
      setInternalState(utils.updater({loggedOut: true}, true));

      if (reset) {
        clearAuthStorage(true);
      }
    }
  }, [logout, reset, setAuthLocal, setAuthSession, doLogout.mutation, auth?.authId, navigate])

  const renderForm = () => {
    return <Box className="LogoutPage-loading">
      <CircularProgress />
      <H6>Logging out</H6>
      {internalState.loggedOut ? <Navigate to="/auth/login"
                                           state={{
                                             from: location.state?.from,
                                             resetSearchParams: true
                                           }}
                                           replace={true}/> : null}
    </Box>
  }

  return <StyledLogoutPage {...innerProps}>
    {renderForm()}
  </StyledLogoutPage>
};

LogoutPage.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default LogoutPage;
